import callApi, { ENDPOINTS } from 'utils/api/callApi'

export enum SEARCH_TYPE {
  Admin = 'transfix_admin',
  Carrier = 'carrier',
  Shipper = 'shipper',
  CarrierUsers = 'carrier_users',
  Dispatcher = 'dispatcher',
}

export interface ICarrierOnChange {
  id?: string
  name?: string
  text?: string
}

export interface INameSearchResult {
  id: string
  name: string
  type: string
  email?: string
}

interface ISearchResults {
  namesearch: INameSearchResult[]
}

interface ICallSearchRequestProps {
  searchType: {
    type: SEARCH_TYPE
    state?: string
    carrierApplicationId?: number
  }
  value: string
}

export const callSearchRequest = ({ searchType, value }: ICallSearchRequestProps): Promise<any> => {
  return callApi({
    params: {
      perPage: 10,
      filters: {
        searchOptions: [searchType],
        searchTerm: `*${value}*`,
      },
    },
    endpoint: ENDPOINTS.search,
  })
}

/**
 * Returns list of search results of shippers matching the typed value
 * @method GET
 * @param value string
 * @returns ISearchResults
 *
 */
export const searchShippers = (
  value: string,
  searchConfirmed: boolean = true
): Promise<ISearchResults> => {
  const searchType = searchConfirmed
    ? { type: SEARCH_TYPE.Shipper, state: 'confirmed' }
    : { type: SEARCH_TYPE.Shipper }
  return callSearchRequest({
    searchType,
    value,
  })
}

/**
 * Returns list of search results of carriers matching the typed value
 * @method GET
 * @param value string
 * @returns ISearchResults
 *
 */
export const searchCarriers = (value: string): Promise<ISearchResults> =>
  callSearchRequest({
    searchType: { type: SEARCH_TYPE.Carrier },
    value,
  })
